exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.full-height{height: 100vh;}\n.center{\n    margin: 0,auto;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/node_modules/postcss-loader?{"ident":"postcss"}!/home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles